module.exports = "/_next/static/images/img__computer-and-books_desktop-e99031fc6136bc18e6401efe58a60b76.png";